<nb-card class="dialog">
  <!-- Header -->
  <nb-card-header class="header">
    <morva-icons class="close-cross" icon="close" (click)="closeDialog()"></morva-icons>
    <p data-testid="dashboard-id-header-text" class="header-text">بارگذاری داشبورد</p>
  </nb-card-header>

  <!-- Body -->
  <nb-card-body class="body">
    <div (click)="dashboardFacade.backImportStep()" *ngIf="dashboardFacade.state().importStepIndex > 0" class="return-btn d-flex align-items-center justify-content-end">
      <div >
        <span>بازگشت</span>
      </div>
      <morva-icons icon="caretLeftOutline" class="icon-16 mx-1"></morva-icons>
    </div>
    <div class="blue-box border-blue-box" *ngIf="!(dashboardFacade.state().importIsLastStep)">
      <div class="blue-box-header">
        <morva-icons icon="activeInfoCircle" class="cursor-pointer icon-24 ms-2"></morva-icons>
        <p class="text">اطلاع‌رسانی</p>
      </div>
      <p class="text px-2 me-4">برای هر منبع داده موجود در فایل، باید یک منبع داده جدید انتخاب شود.</p>
      <p class="text px-2 me-4">در صورتی که ساختار منبع داده انتخاب‌شده با فایل سازگار نباشد، امکان ساخت داشبورد با داده وجود نخواهد داشت.</p>
    </div>
    <div class="blue-box" *ngIf="dashboardFacade.state().importIsLastStep">
      <p class="text">همه‌ی منابع داده با موفقیت انتخاب شده‌اند.</p>
    </div>
    <form [formGroup]="form" class="form-horizontal pt-3">
      <!-- audience -->
      <div>
        <div *ngIf="!(dashboardFacade.state().importIsLastStep)"
          class="d-flex justify-content-between align-items-center">
          <div class="label-with-icon">
            <label class="text" [nbTooltip]="dashboardFacade.state().importCurrentDatasource?.name" [nbTooltipDisabled]="
              dashboardFacade.state().importCurrentDatasource?.name?.length <= 25
            ">
              منبع داده
              "{{
              dashboardFacade.state().importCurrentDatasource?.name?.length > 25
              ? (dashboardFacade.state().importCurrentDatasource?.name | slice: 0 : 25) + '...'
              : dashboardFacade.state().importCurrentDatasource?.name
              }}"
            </label>

          </div>
          <div class="count-datasources">
            منبع داده
            {{dashboardFacade.state().importTotalSteps -1 |persianNumber}} / <span class="current-datasource-number">{{dashboardFacade.state().importStepIndex +1 |persianNumber}}</span>
          </div>
        </div>
        <div *ngIf="!(dashboardFacade.state().importIsLastStep)">
          <button *ngIf="!tempSelectedDatasourceName" nbButton
            class="d-flex justify-content-between align-items-center select-datasource px-3 py-1 w-100"
            [mat-menu-trigger-for]="selectDatasource">
            <span class="select-datasource-text">انتخاب منبع داده</span>
            <morva-icons icon="caretDownOutline" class="icon-18"></morva-icons>
          </button>
          <div *ngIf="tempSelectedDatasourceName" [ngClass]="{
            'error': dashboardFacade.state().importCurrentDatasource?.errors?.length > 0
          }"
            class="d-flex justify-content-between align-items-center selected-datasource-display"
            [mat-menu-trigger-for]="selectDatasource">
            <span class="datasource-name" [nbTooltip]="tempSelectedDatasourceName"
              [nbTooltipDisabled]="tempSelectedDatasourceName?.length <= 25">
              {{
              tempSelectedDatasourceName.length > 25
              ? (tempSelectedDatasourceName | slice:0:25) + '...'
              : tempSelectedDatasourceName
              }}
            </span>

            <div class="d-flex justify-content-end align-items-center ps-1">
              <morva-icons class="cursor-pointer icon-18 me-2" icon="close" (click)="clearSelection($event)">
              </morva-icons>
              <morva-icons class="icon-18" icon="caretDownOutline"></morva-icons>
            </div>
          </div>

          <mat-menu #selectDatasource="matMenu" (closed)="resetShowDatasources()" class="datasource-menu">
            <input #searchDatasourceKey nbInput fullWidth class="search-box mt-2 mx-1" type="text" placeholder="جستجو"
              (click)="$event.stopPropagation()" (input)="searchDatasource(searchDatasourceKey.value)">
            <div class="d-flex flex-column justify-content-start pb-2 px-2 menu-items datasource-menu-items"
              style="max-height: 200px; overflow-y: auto;" (scroll)="onMenuScroll($event)">
              <div class="d-flex justify-content-start align-items-center mt-2 cursor-pointer datasource-item"
                (click)="selectDatasourceItem(datasource.assetId)"
                *ngFor="let datasource of showDatasourceList; let index = index">
                <span class="datasource-name" [nbTooltip]="datasource.assetName"
                  [nbTooltipDisabled]="datasource.assetName?.length <= 45">
                  {{
                  datasource.assetName?.length > 45
                  ? (datasource.assetName | slice:0:45) + '...'
                  : datasource.assetName
                  }}
                </span>

              </div>
              <div *ngIf="isLoadingDatasources" class="d-flex justify-content-center p-2">
                <nb-spinner size="small" [message]="null"></nb-spinner>
              </div>
            </div>
          </mat-menu>

        </div>
        <morva-linear-notifiction *ngIf="dashboardFacade.state().importCurrentDatasource?.errors?.length > 0"
          [message]="'ساختار منبع داده با داشبورد همخوانی ندارد.'" [messageType]="'importError'">
        </morva-linear-notifiction>
        <div *ngIf="dashboardFacade.state().importCurrentDatasource?.errors?.length > 0" class="red-box">
          <div class="blue-box-header">
            <div>
              <p class="red-text">
                موارد خطا
                ({{ dashboardFacade.state().importCurrentDatasource.errors.length | persianNumber }})
              </p>
            </div>

            <div class="d-flex justify-content-center align-items-center gap-2">
              <p *ngIf="!isErrorExpanded" class="red-text">
                بیشتر
              </p>

              <p *ngIf="isErrorExpanded" class="red-text">
                کمتر
              </p>

              <morva-icons (click)="toggleErrorBox()" [icon]="isErrorExpanded ? 'caretUpOutline' : 'caretDownOutline'"
                class="float-end icon-12 cursor-pointer mt-1"></morva-icons>
            </div>
          </div>

          <div *ngIf="isErrorExpanded" class="red-box-body">
            <div class="red-box-inside-body">
              <div *ngFor="let error of dashboardFacade.state().importCurrentDatasource.errors"
                class="d-flex align-items-start">
                <morva-icons icon="closeCircleRed"></morva-icons>
                <span class="red-text ms-1" [nbTooltip]="error" [nbTooltipDisabled]="error?.length <= 80">
                  {{
                  error?.length > 80
                  ? (error | slice:0:80) + '...'
                  : error
                  }}
                </span>

              </div>
            </div>
          </div>
        </div>

        <div
        [ngClass]="dashboardFacade.state().importIsLastStep?'last-step-gray-box':'gray-box'">
          
          <div *ngFor="let ds of dashboardFacade.state().importDatasources; let i = index">
            <ng-container >
              <!-- prev steps -->
              <ng-container *ngIf="i < dashboardFacade.state().importStepIndex">
                <div class="d-flex align-items-center gap-2">
                  <morva-icons icon="importcheckIcon"></morva-icons>
                  <span [nbTooltip]="ds.name" [nbTooltipDisabled]="ds.name?.length <= 20">
                    {{ ds.name?.length > 20 ? (ds.name | slice:0:20) + '...' : ds.name }}
                  </span>
                  <morva-icons icon="importArrowIcon"></morva-icons>
                  <span [nbTooltip]="ds.selectedDataSourceName" [nbTooltipDisabled]="ds.selectedDataSourceName?.length <= 20">
                    {{ ds.selectedDataSourceName?.length > 20 ? (ds.selectedDataSourceName | slice:0:20) + '...' : ds.selectedDataSourceName }}
                  </span>
                </div>
              </ng-container>
        
              <!-- current step -->
              <ng-container *ngIf="i === dashboardFacade.state().importStepIndex && tempSelectedDatasourceName">
                <div class="d-flex align-items-center gap-2 me-4">
                  <span [nbTooltip]="ds.name" [nbTooltipDisabled]="ds.name?.length <= 20">
                    {{ ds.name?.length > 20 ? (ds.name | slice:0:20) + '...' : ds.name }}
                  </span>
                  <morva-icons icon="importArrowIcon"></morva-icons>
                  <span [nbTooltip]="tempSelectedDatasourceName" [nbTooltipDisabled]="tempSelectedDatasourceName?.length <= 20">
                    {{ tempSelectedDatasourceName.length > 20 ? (tempSelectedDatasourceName | slice:0:20) + '...' : tempSelectedDatasourceName }}
                  </span>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
        

      </div>

      <!-- Footer -->
      <nb-card-footer class="d-flex justify-content-end footer px-0" [ngClass]="{ 'pt-0': showWarning }">
        <button nbButton class="confirm-button ms-2" (click)="onConfirm()" [disabled]="
          dashboardFacade.state().importLoading || dashboardFacade.state().importFinalizeLoading ||
          dashboardFacade.state().importCurrentDatasource?.status === false
        ">
          {{
          dashboardFacade.state().importIsLastStep
          ? 'ایجاد داشبورد'
          : 'ادامه'
          }}
        </button>

      </nb-card-footer>
    </form>
  </nb-card-body>
</nb-card>